import { cogZoomOpacityThresholds, DEFAULT_COG_OPACITY, cogZoomOpacityThresholdsDimmed } from '../consts/rasterOpacity';
import { GoogleBasemapNames, Platforms } from '../types';

/**
 * Returns the opacity for an area-emissions raster at the current zoom level.
 * Non-dimmed rasters use the default zoom thresholds, while dimmed rasters
 * use thresholds that vary by platform and basemap.
 */
export const getCOGOpacity = ({
    dimmed,
    mapName,
    platform,
    zoom
}: {
    dimmed: boolean;
    mapName: GoogleBasemapNames;
    platform: Platforms;
    zoom: number;
}) => {
    const thresholds = dimmed ? cogZoomOpacityThresholdsDimmed[platform][mapName] : cogZoomOpacityThresholds;

    const { opacity } =
        thresholds.find(({ minExclusive, maxInclusive }) => {
            return zoom > minExclusive && zoom <= maxInclusive;
        }) || {};

    return typeof opacity === 'number' ? opacity : DEFAULT_COG_OPACITY;
};
